import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  title: 'Estimated {{orderMethod}}: {{day}} around {{time}}',
  status: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Order rejected',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Order received',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Your order has been seen',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Order confirmed',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Order is ready',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Order is being delivered',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Order is completed',
    },
  },
  labels: {
    today: 'Today',
  },
  waiting_confirmation: {
    title: 'Awaiting order confirmation',
    description: 'Hold tight...',
  },
  pickup_time: {
    title: 'Pickup time',
    description: 'Confirmed from {{name}}',
  },
  delivery_time: {
    title: 'Delivery time',
    description: 'Confirmed from {{name}}',
  },
  warning_label: {
    pickup_time_changed: '{{company}} changed the time from {{initialTime}} to {{currentTime}}',
  },
};
